<!-- Ported from vendor-ref/mara/app/ui/src/components/Logo.vue; assets from mara/app/ui/public/nanome-logo*.svg -->
<script setup lang="ts">
import { computed } from 'vue';
import { useDevice } from '@/composables/device';

const props = defineProps<{ responsive?: boolean }>();
const device = useDevice();

const fullLogo = computed(() => device.isDark.value ? '/nanome-logo.svg' : '/nanome-logo-dark.svg');
const iconLogo = computed(() => device.isDark.value ? '/nanome-logo-icon.svg' : '/nanome-logo-icon-dark.svg');
const src = computed(() => device.breakpoints.md.value || !props.responsive ? fullLogo.value : iconLogo.value);
</script>

<template>
  <img :src="src" alt="Nanome" class="block h-6 select-none">
</template>
